import axios from 'axios'

// Create axios instance
const service = axios.create({
  baseURL: '/gatewayApi',
  // baseURL: 'http://localhost:8081',
  timeout: 15000
})

// Request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
service.interceptors.response.use(
  response => {
    // 如果是文件下载，直接返回响应
    if (response.config.responseType === 'blob') {
      return response.data
    }

    const res = response.data
    if (res.code === 200) {
      if(res.data){
        return res.data
      }else{
        return res
      }
    } else {
      console.error('API Error:', res.msg)
      return Promise.reject(new Error(res.msg || 'Error'))
    }
  },
  error => {
    console.error('Response error:', error)
    return Promise.reject(error)
  }
)

export default service
